// Render a parsed reaction Formula via KaTeX.

import katex from "katex";
import "katex/dist/katex.min.css";
import { useMemo } from "react";

import { formulaToLatex } from "../formula/latex";
import { FormulaParseError, parseFormula } from "../formula/parse";
import type { MaterialResolver } from "../formula/types";

export interface FormulaProps {
  source: string;
  resolver: MaterialResolver;
  display?: boolean;
}

export function Formula({ source, resolver, display = true }: FormulaProps) {
  const html = useMemo(() => {
    try {
      const parsed = parseFormula(source);
      const latex = formulaToLatex(parsed, resolver);
      return katex.renderToString(latex, {
        displayMode: display,
        throwOnError: false,
      });
    } catch (err) {
      if (err instanceof FormulaParseError) {
        return `<span class="formula-error">${escape(err.message)}</span>`;
      }
      const message = err instanceof Error ? err.message : String(err);
      return `<span class="formula-error">${escape(message)}</span>`;
    }
  }, [source, resolver, display]);
  return <div className="formula" dangerouslySetInnerHTML={{ __html: html }} />;
}

function escape(s: string): string {
  return s.replace(/[&<>"]/g, (c) => {
    switch (c) {
      case "&":
        return "&amp;";
      case "<":
        return "&lt;";
      case ">":
        return "&gt;";
      case '"':
        return "&quot;";
      default:
        return c;
    }
  });
}
